<mat-card>
  <mat-card-header>
    <mat-card-title>Gestión de Origen</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>
    <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
    <mat-label *ngIf="!isSearching && msgError.length > 0">{{msgError}}</mat-label>

    <div *ngIf="!isSearching && item != null">

      <ng-container *ngIf="canEdit">
        <form [formGroup]="formGroup">
          <div fxLayout="row wrap" fxLayoutGap="16px" fxLayout.xs="column">

            <div fxFlex="0 1 calc(50% - 16px)" fxFlex.xs="100">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Código*</mat-label>
                <input matInput formControlName="Codigo" maxlength="100">
                <mat-error *ngIf="!formGroup.controls['Codigo'].valid && formGroup.controls['Codigo'].touched">
                  {{ getErrorCodigo() }}
                </mat-error>
              </mat-form-field>
            </div>

            <div fxFlex="0 1 calc(50% - 16px)" fxFlex.xs="100">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Nombre*</mat-label>
                <input matInput formControlName="Nombre" maxlength="100">
                <mat-error *ngIf="!formGroup.controls['Nombre'].valid && formGroup.controls['Nombre'].touched">
                  {{ getErrorNombre() }}
                </mat-error>
              </mat-form-field>
            </div>

            <div fxFlex="0 1 calc(33.33% - 16px)" fxFlex.xs="100">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Handling*</mat-label>
                <input matInput type="number" formControlName="Handling">
                <mat-error *ngIf="!formGroup.controls['Handling'].valid && formGroup.controls['Handling'].touched">
                  {{ getErrorHandling() }}
                </mat-error>
              </mat-form-field>
            </div>

            <div fxFlex="0 1 calc(33.33% - 16px)" fxFlex.xs="100">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Costo de Almacenaje</mat-label>
                <input matInput type="number" formControlName="CostoAlmacenaje">
                <mat-error
                  *ngIf="!formGroup.controls['CostoAlmacenaje'].valid && formGroup.controls['CostoAlmacenaje'].touched">
                  {{ getErrorCostoAlmacenaje() }}
                </mat-error>
              </mat-form-field>
            </div>

            <div fxFlex="0 1 calc(33.33% - 16px)" fxFlex.xs="100">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Días Almacenaje</mat-label>
                <input matInput type="number" formControlName="DiasAlmacenaje">
                <mat-error
                  *ngIf="!formGroup.controls['DiasAlmacenaje'].valid && formGroup.controls['DiasAlmacenaje'].touched">
                  {{ getErrorDiasAlmacenaje() }}
                </mat-error>
              </mat-form-field>
            </div>

            <div fxFlex="100">
              <mat-checkbox [(ngModel)]="item.Activo" [ngModelOptions]="{standalone: true}"
                color="primary">Activo</mat-checkbox>
            </div>

          </div>

          <div
            style="border: 1px solid #ccc; border-radius: 4px; padding: 16px; margin-top: 20px; margin-bottom: 20px;">

            <div fxLayout="row" fxLayoutAlign="space-between center" style="margin-bottom: 16px;">
              <h3 style="margin: 0; font-weight: 500;">Bandas de Costo (Por Kilo)</h3>
              <button mat-stroked-button color="primary" type="button" (click)="agregarRango()"
                [disabled]="editingIndex !== null">
                <mat-icon>add</mat-icon> Agregar Banda
              </button>
            </div>

            <div *ngIf="item.Rangos && item.Rangos.length > 0" fxLayout="row" fxLayoutGap="16px"
              style="font-weight: bold; padding-bottom: 8px; border-bottom: 1px solid #eee; margin-bottom: 8px;">
              <div fxFlex="30">Peso Desde (Kg)</div>
              <div fxFlex="30">Peso Hasta (Kg)</div>
              <div fxFlex="30">Costo ($)</div>
              <div fxFlex="10" style="text-align: center;">Acciones</div>
            </div>

            <div *ngIf="!item.Rangos || item.Rangos.length === 0"
              style="color: #888; text-align: center; padding: 20px;">
              No hay bandas de costo configuradas. Agregue al menos una para calcular el flete.
            </div>

            <div *ngFor="let rango of item.Rangos; let i = index" fxLayout="row" fxLayoutAlign="start center"
              fxLayoutGap="16px" style="margin-bottom: 12px;">

              <ng-container *ngIf="editingIndex !== i">
                <div fxFlex="30">
                  <span [style.color]="rango.PesoDesde == null ? '#888' : 'inherit'">
                    {{ rango.PesoDesde != null ? (rango.PesoDesde + ' kg') : 'Inicio (0)' }}
                  </span>
                </div>

                <div fxFlex="30">
                  <span [style.color]="rango.PesoHasta == null ? '#3f51b5' : 'inherit'"
                    [style.font-weight]="rango.PesoHasta == null ? '500' : 'normal'">
                    {{ rango.PesoHasta != null ? (rango.PesoHasta + ' kg') : 'En adelante (+)' }}
                  </span>
                </div>

                <div fxFlex="30">{{ rango.Costo | currency }}</div>

                <div fxFlex="10" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px">
                  <button mat-icon-button color="primary" type="button" (click)="editarRango(i)" matTooltip="Editar"
                    [disabled]="editingIndex !== null">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button mat-icon-button color="warn" type="button" (click)="eliminarRango(i)" matTooltip="Eliminar"
                    [disabled]="editingIndex !== null">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </ng-container>

              <ng-container *ngIf="editingIndex === i">
                <div fxFlex="30">
                  <mat-form-field appearance="outline" style="width: 100%; margin-bottom: -1.25em;">
                    <input matInput type="number" [(ngModel)]="rangoEditTemp.PesoDesde"
                      [ngModelOptions]="{standalone: true}" placeholder="Mínimo (Vacío = 0)">
                    <mat-hint *ngIf="rangoEditTemp.PesoDesde == null" style="font-size: 10px;">Comienza en 0</mat-hint>
                  </mat-form-field>
                </div>

                <div fxFlex="30">
                  <mat-form-field appearance="outline" style="width: 100%; margin-bottom: -1.25em;">
                    <input matInput type="number" [(ngModel)]="rangoEditTemp.PesoHasta"
                      [ngModelOptions]="{standalone: true}" placeholder="Máximo (Vacío = +)">
                    <mat-hint *ngIf="rangoEditTemp.PesoHasta == null" style="font-size: 10px;">Hacia el
                      infinito</mat-hint>
                  </mat-form-field>
                </div>

                <div fxFlex="30">
                  <mat-form-field appearance="outline" style="width: 100%; margin-bottom: -1.25em;">
                    <input matInput type="number" [(ngModel)]="rangoEditTemp.Costo"
                      [ngModelOptions]="{standalone: true}" placeholder="Precio">
                  </mat-form-field>
                </div>

                <div fxFlex="10" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px">
                  <button mat-icon-button style="color: green;" type="button" (click)="guardarEdicionRango(i)"
                    matTooltip="Confirmar">
                    <mat-icon>check</mat-icon>
                  </button>
                  <button mat-icon-button color="warn" type="button" (click)="cancelarEdicionRango()"
                    matTooltip="Cancelar">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              </ng-container>

            </div>
          </div>
        </form>
      </ng-container>

      <ng-container *ngIf="!canEdit">
        <div fxLayout="row wrap" fxLayoutGap="16px" class="zb-readonly">
          <div fxFlex="100">
            <p><b>Código:</b> {{item.Codigo}}</p>
            <p><b>Nombre:</b> {{item.Nombre}}</p>
            <p><b>Handling:</b> {{item.Handling | number:'1.2-2'}}</p>
            <p *ngIf="item.CostoAlmacenaje != null"><b>Costo Almacenaje:</b> {{item.CostoAlmacenaje | number:'1.2-2'}}%
            </p>
            <p *ngIf="item.DiasAlmacenaje != null"><b>Días Almacenaje:</b> {{item.DiasAlmacenaje | number:'1.2-2'}}</p>
            <p><b>Activo:</b> {{item.Activo ? 'Sí' : 'No'}}</p>
          </div>

          <div fxFlex="100" style="margin-top: 16px;">
            <h3 style="border-bottom: 1px solid #ccc; padding-bottom: 8px;">Bandas de Costo</h3>
            <ul style="list-style-type: none; padding-left: 0;">
              <li *ngFor="let rango of item.Rangos" style="padding: 4px 0;">
                De <b>{{rango.PesoDesde}}kg</b> a <b>{{rango.PesoHasta}}kg</b>: {{rango.Costo | currency}}
              </li>
              <li *ngIf="!item.Rangos || item.Rangos.length === 0">No hay bandas configuradas.</li>
            </ul>
          </div>
        </div>
      </ng-container>

    </div>
  </mat-card-content>

  <mat-card-actions style="margin-bottom: 20px;">
    <div fxLayout="row" fxLayoutGap="16px" fxLayout.xs="column">
      <button mat-raised-button (click)="onGuardar()" *ngIf="canEdit"
        [disabled]="isProcessing() || editingIndex !== null" color="primary">
        {{isSaving ? 'Guardando...' : 'Guardar'}}
      </button>
      <button mat-raised-button (click)="onCancel()" color="warn">
        {{canAdd || canEdit ? 'Cancelar' : 'Cerrar'}}
      </button>
      <button mat-raised-button (click)="onDelete()" *ngIf="canDelete && item != null && item.Id > 0"
        [disabled]="isSaving" color="accent">
        {{ isDeleting ? 'Eliminando...' : 'Eliminar' }}
      </button>
    </div>
  </mat-card-actions>
</mat-card>